import { RowElement } from '@mobileTypes'

export const DEFAULT_ROW_ELEMENT: Partial<RowElement> = {
  order: 0,
  pinnedColumn: null,
  objectValue: null,
  pathArray: null,
  actions: [],
  columnToSort: null,
  valueType: null,
  fieldType: 'single',
  bindType: 'field',
  formatDate: null,
  editable: true,
  enumDescription: false,
  visibility: true,
  useLocalParameters: false,
  useDisplayRule: false,
  isPk: null,
  parameters: [],
  restrictions: null,
  valueFormat: null,
  displayRule: null,
  preFill: null,
}
